module.exports = __webpack_public_path__ + "img/detail4.d97db345.jpg";